import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=66864961&"
import script from "./RequestDetails.vue?vue&type=script&lang=js&"
export * from "./RequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports